import React, { useState, useEffect, useRef } from 'react';

import './style.scss';
import Button from '../Button/Button';
import Image from '../Media/Media';
import Text from '../Text/Text';

const SingleSelect = (props) => {
  const [selectedOption, setSelectedOption] = useState();
  const [displayDescriptionBox, setDispalyDescriptionBox] = useState('none');

  const {
    options,
    answer,
    solution,
    slideIndex,
    nextSlide,
    syncSlides,
    flashcardId,
    userResponse,
    optionType,
    style,
  } = props;
  const solutionSectionRef = useRef(null);
  const optionColor = style?.color;

  const solutionObjLength = Object.keys(solution).length;

  useEffect(() => {
    if (solutionSectionRef.current) {
      solutionSectionRef.current.scrollIntoView({
        behavior: 'smooth',
        block: 'center',
      });
    }
  }, [selectedOption]);

  useEffect(() => {
    if (userResponse) setSelectedOption(Number(userResponse));
  }, []);

  return (
    <div className='single-select'>
      {optionType === 'image' ? (
        <div className='single-select-options-box'>
          {options.map((optionValue, index) => (
            <button
              className='single-select-option-button'
              key={index}
              style={{
                borderColor:
                  selectedOption && selectedOption === optionValue.sNo
                    ? selectedOption === answer
                      ? '#1BB55C'
                      : '#DD234C'
                    : optionColor && optionType === 'text'
                    ? optionColor
                    : '#CED4DA',
                cursor: selectedOption ? 'default' : '',
                color: optionColor,
              }}
              disabled={selectedOption === undefined ? false : true}
              onClick={() => {
                setSelectedOption(optionValue.sNo);
                setDispalyDescriptionBox('flex');
                syncSlides(
                  {
                    flashcard_id: flashcardId,
                    user_response: optionValue.sNo,
                    is_correct: optionValue.sNo === answer,
                    is_read: true,
                  },
                  true
                );
              }}
            >
              <div className='option-div'>
                {String.fromCharCode(65 + index)}
              </div>

              <img
                src={optionValue.imageUrl}
                className='option-image'
                alt='option'
              />

              {selectedOption &&
                (optionValue.sNo === answer ? (
                  <p className='correct-answer'> Correct </p>
                ) : optionValue.sNo === selectedOption &&
                  selectedOption !== answer ? (
                  <p className='wrong-answer'> Incorrect </p>
                ) : (
                  <></>
                ))}
            </button>
          ))}
        </div>
      ) : (
        <div className='single-select-options-box-text'>
          {options.map((optionValue, index) => (
            <button
              className='single-select-option-button'
              key={index}
              style={{
                borderColor:
                  selectedOption && selectedOption === optionValue.sNo
                    ? selectedOption === answer
                      ? '#1BB55C'
                      : '#DD234C'
                    : optionColor && optionType === 'text'
                    ? optionColor
                    : '#CED4DA',
                cursor: selectedOption ? 'default' : '',
                color: optionColor,
              }}
              disabled={selectedOption === undefined ? false : true}
              onClick={() => {
                setSelectedOption(optionValue.sNo);
                setDispalyDescriptionBox('flex');
                syncSlides(
                  {
                    flashcard_id: flashcardId,
                    user_response: optionValue.sNo,
                    is_correct: optionValue.sNo === answer,
                    is_read: true
                  },
                  true
                );
              }}
            >
              <div className='option-div'>
                {String.fromCharCode(65 + index)}
              </div>
              <div className='option-text'>{optionValue?.text?.trim()}</div>
              {selectedOption &&
                (optionValue.sNo === answer ? (
                  <p className='correct-answer'> Correct </p>
                ) : optionValue.sNo === selectedOption &&
                  selectedOption !== answer ? (
                  <p className='wrong-answer'> Incorrect </p>
                ) : (
                  <></>
                ))}
            </button>
          ))}
        </div>
      )}

      {solutionObjLength ? (
        <div
          className='answer-description-box'
          style={{ display: displayDescriptionBox }}
          ref={solutionSectionRef}
        >
          {(solution.solutionText || solution.image) && (
            <div
              className='solution-title'
              style={{ color: optionColor ? optionColor : '#495057' }}
            >
              Solution
            </div>
          )}
          {solution.solutionText && <Text {...solution.solutionText} />}
          {solution.image && <Image {...solution.image} />}
          {solution.button && (
            <Button {...{ ...solution.button, nextSlide, slideIndex }} />
          )}
        </div>
      ) : null}
    </div>
  );
};

export default SingleSelect;
